var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:mic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 19.5C10.8978 19.5 11.2794 19.658 11.5607 19.9393C11.842 20.2206 12 20.6022 12 21V24C12 27.1826 13.2643 30.2348 15.5147 32.4853C17.7652 34.7357 20.8174 36 24 36C27.1826 36 30.2348 34.7357 32.4853 32.4853C34.7357 30.2348 36 27.1826 36 24V21C36 20.6022 36.158 20.2206 36.4393 19.9393C36.7206 19.658 37.1022 19.5 37.5 19.5C37.8978 19.5 38.2794 19.658 38.5607 19.9393C38.842 20.2206 39 20.6022 39 21V24C39 27.7186 37.6188 31.3046 35.1244 34.0624C32.6299 36.8202 29.1999 38.5531 25.5 38.925V45H34.5C34.8978 45 35.2794 45.158 35.5607 45.4393C35.842 45.7206 36 46.1022 36 46.5C36 46.8978 35.842 47.2794 35.5607 47.5607C35.2794 47.842 34.8978 48 34.5 48H13.5C13.1022 48 12.7206 47.842 12.4393 47.5607C12.158 47.2794 12 46.8978 12 46.5C12 46.1022 12.158 45.7206 12.4393 45.4393C12.7206 45.158 13.1022 45 13.5 45H22.5V38.925C18.8001 38.5531 15.3701 36.8202 12.8756 34.0624C10.3812 31.3046 8.99995 27.7186 9 24V21C9 20.6022 9.15804 20.2206 9.43934 19.9393C9.72064 19.658 10.1022 19.5 10.5 19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 24C30 25.5913 29.3679 27.1174 28.2426 28.2426C27.1174 29.3679 25.5913 30 24 30C22.4087 30 20.8826 29.3679 19.7574 28.2426C18.6321 27.1174 18 25.5913 18 24V9C18 7.4087 18.6321 5.88258 19.7574 4.75736C20.8826 3.63214 22.4087 3 24 3C25.5913 3 27.1174 3.63214 28.2426 4.75736C29.3679 5.88258 30 7.4087 30 9V24ZM24 0C21.6131 0 19.3239 0.948211 17.636 2.63604C15.9482 4.32387 15 6.61305 15 9V24C15 26.3869 15.9482 28.6761 17.636 30.364C19.3239 32.0518 21.6131 33 24 33C26.3869 33 28.6761 32.0518 30.364 30.364C32.0518 28.6761 33 26.3869 33 24V9C33 6.61305 32.0518 4.32387 30.364 2.63604C28.6761 0.948211 26.3869 0 24 0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.5449d51a221bd2ce71f65366ecd8a2e0.svg";
export { ForwardRef as ReactComponent };